var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-responsive',{attrs:{"aspect-ratio":16 / 9}},[_c('iframe',{staticClass:"d-flex",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.link,"frameborder":"0","allow":"autoplay; fullscreen","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }